import Header from '../../../components/header'
import useBack from '../../../modules/navigation/hooks/use-back'
import withStore from '../../../utils/with-store'
import Benefits from './components/benefits'
import Contact from './components/contact'
import Faq from './components/faq'
import Intro from './components/intro'
import Meta from './components/meta'
import MonthlyToggle from './components/monthly-toggle'
import Plans from './components/plans'
import ReceivedInvite from './components/received-invite'
import SendInvites from './components/send-invites'
import Testimonials from './components/testimonials'
import { PricingEl } from './elements'
import PricingStore from './stores/pricing-store'

const Pricing = () => {
  useBack('/')

  return (
    <PricingEl id='pricing'>
      <Header
        subtitle='LivDemy pricing and Subscription plans'
        title='Pricing'
      />
      <Meta />
      <Intro />
      <ReceivedInvite />
      <SendInvites />
      <MonthlyToggle />
      <Plans />
      <Benefits />
      <Testimonials />
      <Faq />
      <Contact />
    </PricingEl>
  )
}

export default withStore([PricingStore])(Pricing)
